module.exports = __webpack_public_path__ + "img/6.c9a33303.png";